import React, { Component } from 'react';
import AboutForm from './AboutForm';
import NavBar from '../NavBar/NavBar';
import './About.css';


class About extends Component {
  render () {
    return (
      <div className="AboutPage">
        <NavBar />
        <AboutForm />
      </div>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.js